var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8539",
    "data-name": "Group 8539",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 22,
    viewBox: "0 0 23.999 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M6.249,15.925a3.744,3.744,0,0,1-3.542-2.551l-.035-.115A3.647,3.647,0,0,1,2.5,12.175V5.357l-2.426,8.1A2.271,2.271,0,0,0,1.665,16.21l15.462,4.141a2.3,2.3,0,0,0,.576.074,2.229,2.229,0,0,0,2.161-1.635l.9-2.865Z",
    transform: "translate(0 1.575)",
    fill: "#7b7b7b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M7.408,6.318a2,2,0,1,0-2-2A2,2,0,0,0,7.408,6.318Z",
    transform: "translate(1.59 0.682)",
    fill: "#7b7b7b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M20.59,0h-15a2.5,2.5,0,0,0-2.5,2.5v11a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5V2.5A2.5,2.5,0,0,0,20.59,0Zm-15,2h15a.5.5,0,0,1,.5.5V9.6L17.931,5.913A1.791,1.791,0,0,0,16.59,5.3a1.748,1.748,0,0,0-1.336.631L11.54,10.387,10.33,9.18a1.755,1.755,0,0,0-2.48,0l-2.76,2.759V2.5A.5.5,0,0,1,5.591,2Z",
    transform: "translate(0.909)",
    fill: "#7b7b7b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgImg);
export default __webpack_public_path__ + "static/media/img-img.3e95534bebc591dd99856cebe4014e19.svg";
export { ForwardRef as ReactComponent };